import React from 'react';
import Toeic from './Toeic.js';



const ToeicPage = () => {
    return (
        <div>
            <h1>TOEIC Style Exam</h1>
            <Toeic />
        </div>
    );
};


export default ToeicPage;